<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import './globalStyle/global.less';

export default {
  created() {
    const { navigator: { language } } = window;
    this.$store.commit('updateState', {
      language,
      windowSize: {
        height: document.documentElement.clientHeight,
        width: document.documentElement.clientWidth,
      },
    });
    window.addEventListener('resize', () => {
      this.$store.commit('updateState', {
        windowSize: {
          height: document.documentElement.clientHeight,
          width: document.documentElement.clientWidth,
        },
      });
    });
  },
};
</script>

<style lang="less">
</style>
